export const contingentArrowForwardIcon = {
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 11"><path d="M1.155.069A.176.176 0 00.91.036L.072.681a.176.176 0 00-.033.247L3.555 5.5.036 10.072a.176.176 0 00.033.247l.84.645a.176.176 0 00.246-.033l4.098-5.323a.176.176 0 000-.216L1.155.07z" fill="#1A80BA"/></svg>`,
  name: 'arrow-forward',
};
